import React, { useState } from "react";
import logo from "../../assets/image/logo.png";

const sections = [
    {
        title: "About",
        links: [{ text: "About Us", href: "#" }],
    },
    {
        title: "Support",
        links: [
            { text: "Delivery Support", href: "#" },
            { text: "Contact Us", href: "mailto:susanadhikari3@gmail.com" },
            { text: "Terms of use", href: "#" },
            { text: "Privacy policy", href: "#" },
        ],
    },
    {
        title: "Cities",
        links: [
            { text: "Kathmandu", href: "#" },
            { text: "Lalitpur", href: "#" },
            { text: "Nuwakot", href: "#" },
            { text: "More…", href: "#" },
        ],
    },
];

export default function Footer() {
    const [open, setOpen] = useState(null);
    const toggle = (i) => setOpen(open === i ? null : i);

    return (
        <>
            <footer className="bg-dark text-white pt-4 ">
                <div className="container">
                    <div className="row d-sm-none d-none d-md-flex">
                        {sections.map((s, i) => (
                            <div className="col-6 col-lg-3 mb-4" key={i}>
                                <h6 className="fw-bold mb-3">{s.title}</h6>
                                <ul className="list-unstyled">
                                    {s.links.map((l) => (
                                        <li key={l.text} className="mb-2">
                                            <a href={l.href} className="text-muted text-decoration-none">
                                                {l.text}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                        <div className="col-lg-3 mb-4">
                            <h6 className="fw-bold mb-3">Follow us</h6>
                            <div className="d-flex gap-3">
                                <a href="#" className="text-white fs-4"><i className="material-icons">facebook</i></a>
                                <a href="#" className="text-white fs-4"><i className="material-icons">photo_camera</i></a>
                                <a href="#" className="text-white fs-4"><i className="material-icons">ondemand_video</i></a>
                                <a href="#" className="text-white fs-4"><i className="material-icons">chat</i></a>
                            </div>
                        </div>
                    </div>

                    <div className="d-md-none">
                        {sections.map((s, i) => (
                            <div key={i} className="border-bottom border-secondary">
                                <button
                                    className="btn btn-link w-100 text-start text-white d-flex justify-content-between align-items-center py-3"
                                    onClick={() => toggle(i)}
                                >
                                    <span className="fw-bold">{s.title}</span>
                                    <i className="material-icons">
                                        {open === i ? "expand_less" : "expand_more"}
                                    </i>
                                </button>
                                {open === i && (
                                    <ul className="list-unstyled ps-3 pb-2">
                                        {s.links.map((l) => (
                                            <li key={l.text} className="mb-2">
                                                <a href={l.href} className="text-muted text-decoration-none">
                                                    {l.text}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </footer>

            <div className="bg-light py-3">
                <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <p className="mb-2 mb-md-0 text-muted">
                        <img src={logo} alt="Logo" height={20} className="me-2" />
                        © 2022 Narayani Concept. All rights reserved.
                    </p>
                </div>
            </div>
        </>
    );
}